import React, { useEffect, useState } from "react";
import { BlackAndWhite } from "../../../../../themes/Colors";
import Papa from "papaparse";

import {
  BaseButtons,
  CloseButton,
  TextInputFieldSearch,
} from "../../../../../components/atoms";

import AddPopUp from "./add-pop-ups/AddPopUp";
import { LoadingPopUp, ToastNotification } from "../../../../../components";

import EditPopUp from "./edit-pop-up/EditPopUp";
import ListView from "./list-view/ListView";
import CategoryEditPopUp from "./category-edit-popup/CategoryEditPopup";
import UseFilter from "./user-filter/UserFilter";
import ModalPopUp from "../../../../../components/modal-pop-up/ModalPopUp";
import { ModalLayout } from "../../reporting/components";

const Categories = ({ setScreenDisplay }) => {
  const checkIcon = (check) => {
    if (check === "flowers1") {
      return {
        imageIcon: require("../../../../../images/product-icons/flowerBlack.png"),
        imageIcon2: require("../../../../../images/product-icons/flowerWhite2.png"),
      };
    } else {
      return {
        imageIcon: require("../../../../../images/product-icons/otherProdyctsBlack2.png"),
        imageIcon2: require("../../../../../images/product-icons/otherProductsWhite2.png"),
      };
    }
  };

  const [refresh, setRefresh] = useState(false);

  const [filterOption, setFilterOPtion] = useState("product");

  const [displayEditPopUp, setDisplayEditPopUp] = useState(false);

  const [categoryEditPopUp, setCategoryEditPop] = useState(null);
  const [subcategoryEditPopUp, setSubcategoryEditPop] = useState(null);

  const [sectionDisplay, setSectionDisplay] = useState("cat");
  const [category, setCategory] = useState(null);
  const [categorySelected, setCategorySelected] = useState(null);
  const [subCategoryArray, setSubCategoryArray] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [subCategoryProductsArray, setSubCategoryProductsArray] =
    useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [message, setMessage] = useState(null);
  const [toastPop, setToastPop] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isList, setIsList] = useState(true);

  const [search, setSearch] = useState("");
  const [searchOptions, setSearchOptions] = useState("name");

  const [newLoad, setNewLoad] = useState(false);

  const [selectedAdd, setSelectedAdd] = useState(null);

  const [screen, setScreen] = useState("");

  // csv basis for data dump upload

  const [csvUploadPopUp, setCsvUploadPopUp] = useState(false);
  const [prductsCsvArray, setProductsCsvArray] = useState([]);

  const updateProductCsv = async () => {
    setLoading(true);
    // authentication or login function heal
    //this code is used for Ui test
    // https://budloungedatabase.onrender.com/cannaPos/reg

    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/productUpload/productLine/uploadCsvDataProducts",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            productsArray: prductsCsvArray,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.newProduct) {
        // const wait = await updateListFetch();
        setMessage(respnseData.newProduct);
        setToastPop(true);
        setLoading(false);
      } else if (respnseData.message) {
        setToastPop(true);
        setMessage(respnseData.message);
        setLoading(false);
      }
    } catch (err) {
      console.log("err", err);
      setToastPop(true);
      setMessage("Error occured please try again in a few minutes");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch("https://budloungedatabase.onrender.com/productUpload/getCatergories")
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setCategory(resData);
      });
  }, [refresh, newLoad]);
  useEffect(() => {
    if (toastPop) {
      setTimeout(() => {
        setToastPop(false);
      }, 2500);
    }
  }, [toastPop]);
  return (
    <div>
      {/* category display */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          width: "100%",
          height: sectionDisplay === "cat" ? "96%" : 0,
          overflowY: "hidden",
          transition: "all 0.3s",
          position: "absolute",
        }}
      >
        <div
          style={{
            height: 60,
            width: "100%",
            backgroundColor: BlackAndWhite.secondary,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              marginLeft: 20,
              fontSize: 18,
              fontWeight: "bold",
              color: BlackAndWhite.primary,
              transition: "all 0.3s",
              marginRight: 20,
            }}
          >
            {isList ? "ITEMS" : "Product Categories"}
          </div>

          <div style={{ width: 10 }} />

          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "flex-end",
              height: "100%",
            }}
          >
            <div
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                marginRight: 150,
                width: 300,

                borderWidth: 0.5,
              }}
            >
              <TextInputFieldSearch
                placeholder={"Type here to search"}
                height={25}
                borderRadius={4}
                onChange={(e) => setSearch(e.target.value)}
                value={search}
              />
              <div
                style={{
                  height: 30,
                  width: 70,
                  backgroundColor: BlackAndWhite.primary,
                  borderRadius: 4,
                  display: "flex",
                  color: BlackAndWhite.secondary,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  onClick={() => setSearch("")}
                  style={{ fontSize: 12, fontWeight: "bold" }}
                >
                  CLEAR
                </div>
              </div>
            </div>
            {isList ? (
              <div style={{ marginTop: 5 }}>
                <UseFilter filterName={"FILTER"} setScreen={setFilterOPtion} />
              </div>
            ) : // <div
            //   style={{
            //     height: 50,
            //     display: "flex",
            //     marginLeft: 20,
            //     width: 330,
            //     marginRight: 20,
            //     borderRadius: 30,
            //     backgroundColor: BlackAndWhite.primary,
            //     justifyContent: "space-evenly",
            //     alignItems: "center",
            //     color: BlackAndWhite.secondary,
            //     borderStyle: "solid",
            //     borderWidth: 1,
            //     borderColor: "#FAA919",
            //     marginTop: 4,
            //   }}
            // >

            //   {/* <BaseButtons
            //     label={"Products"}
            //     height={30}
            //     marginTopFalse={true}
            //     invert={filterOption === "all" ? true : false}
            //     onClick={() => setFilterOPtion("all")}
            //   />
            //   <BaseButtons
            //     label={"Categories"}
            //     height={30}
            //     marginTopFalse={true}
            //     invert={filterOption === "categories" ? true : false}
            //     onClick={() => setFilterOPtion("categories")}
            //   /> */}
            // </div>
            null}
          </div>
          <div
            style={{
              marginRight: 20,
              // marginTop: 0,
              marginBottom: 17,
              display: "flex",
            }}
          >
            {isList ? (
              <BaseButtons
                height={35}
                label={"+ ADD PRODUCT"}
                fontSize={12}
                onClick={() => setSelectedAdd("completePath")}
              />
            ) : null}

            {isList ? null : (
              <BaseButtons
                height={isList ? 35 : null}
                label={"+ ADD CATEGORY"}
                fontSize={isList ? 12 : null}
                onClick={() => setSelectedAdd("category")}
              />
            )}
          </div>
        </div>
        {isList ? (
          <ListView
            search={search}
            refresh={refresh}
            setRefresh={setRefresh}
            setSubcategoryEditPop={setSubcategoryEditPop}
            data={category ? category.categories : []}
            setMessage={setMessage}
            setToastPop={setToastPop}
            filterOption={filterOption}
            setFilterOPtion={setFilterOPtion}
            setSectionDisplay={setSectionDisplay}
            setSelectedProduct={setSelectedProduct}
            setCategoryEditPop={setCategoryEditPop}
          />
        ) : null}
      </div>
      {/* sub category display */}

      {/* prudcts for sub-sections */}

      {/* single productDisplay */}

      <AddPopUp
        data={category ? category.categories : []}
        setSectionDisplay={setSectionDisplay}
        display={selectedAdd}
        onCloseClick={() => setSelectedAdd(null)}
        setToastPop={setToastPop}
        setSelectedAdd={setSelectedAdd}
        setMessage={setMessage}
        categorySelected={categorySelected}
        setCategorySelected={setCategorySelected}
        selectedSubCategory={selectedSubCategory}
        setRefresh={setRefresh}
        refresh={refresh}
        newLoad={newLoad}
        setNewLoad={setNewLoad}
      />

      <ToastNotification message={message} display={toastPop} />
      <LoadingPopUp display={loading} newWidth={"100%"} />
      <EditPopUp
        display={displayEditPopUp}
        onCloseClick={() => setDisplayEditPopUp(false)}
        setMessage={setMessage}
        setToastPop={setToastPop}
        selectedProduct={selectedProduct}
        setLoading={setLoading}
        setDisplayEditPopUp={setDisplayEditPopUp}
        setSectionDisplay={setSectionDisplay}
        refresh={refresh}
        setRefresh={setRefresh}
      />
      <CategoryEditPopUp
        display={categoryEditPopUp || subcategoryEditPopUp ? true : false}
        onCloseClick={() => {
          setCategoryEditPop(null);
          setSubcategoryEditPop(null);
        }}
        categoryEditPopUp={categoryEditPopUp}
        subcategoryEditPopUp={subcategoryEditPopUp}
        setSubcategoryEditPop={setSubcategoryEditPop}
        setCategoryEditPop={setCategoryEditPop}
        setMessage={setMessage}
        setToastPop={setToastPop}
        setLoading={setLoading}
        refresh={refresh}
        setRefresh={setRefresh}
      />
      <ModalLayout
        display={csvUploadPopUp}
        page={
          <div
            style={{
              // minHeight: 656,
              // minWidth: 600,
              backgroundColor: "#00000050",
              // borderRadius: 20,
              position: "relative",
              display: "flex",
              flexDirection: "row",
              overflow: "hidden",
              height: "100%",
              width: "100%",
              zIndex: 1,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                // minHeight: 656,
                // minWidth: 600,
                backgroundColor: "#FFFFFF",
                // borderRadius: 20,
                position: "relative",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                height: 250,
                width: "50%",
                zIndex: 10,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ position: "absolute", top: 10, left: 10 }}>
                <CloseButton
                  label={"X"}
                  onClick={() => setCsvUploadPopUp(false)}
                />
              </div>
              <div style={{ fontSize: 16, fontWeight: "bold", marginTop: 20 }}>
                CSV UPLOAD PRODUCTS BULK
              </div>
              <div
                style={{
                  flex: 1,

                  width: "90%",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <input
                  type="file"
                  accept=".csv,.xlsx,.xls"
                  onChange={(e) => {
                    const files = e.target.files;
                    console.log(files);
                    if (files) {
                      console.log(files[0]);
                      Papa.parse(files[0], {
                        complete: function (results) {
                          console.log("Finished:", results.data);
                          setProductsCsvArray(results.data);
                        },
                      });
                    }
                  }}
                />
              </div>
              <BaseButtons
                label={"SUBMIT"}
                mini={true}
                size={"90%"}
                onClick={() => updateProductCsv()}
              />
              <div style={{ minHeight: 20 }} />
            </div>
          </div>
        }
      />
    </div>
  );
};
export default Categories;
